import {useEffect} from 'react'
import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

import {SurveyBannerContent} from '../SurveyBannerContent/SurveyBannerContent'
import {useTrustSurvey} from './useTrustSurvey'

const MOBILE_BANNER_MAX_WIDTH = 587

const Wrapper = styled.div`
  padding-bottom: ${cssTheme.layout.spacing.s500};
  max-width: ${MOBILE_BANNER_MAX_WIDTH}px;
  margin-left: auto;
  margin-right: auto;
  ${linariaMq.desktopSm} {
    padding: ${cssTheme.layout.spacing.s500};
    background-color: ${cssTheme.colors.background.neutral.secondary};
    border-radius: ${cssTheme.layout.radius.xl};
    margin-top: ${cssTheme.layout.spacing.s300};
    margin-bottom: ${cssTheme.layout.spacing.s300};
    max-width: initial;
  }
`
interface Props {
  onVisibilityChange?: (isVisible: boolean) => void
}

export const TrustSurveyBanner = ({onVisibilityChange}: Props) => {
  const {
    ref,
    isInitialized,
    isVisible,
    status,
    selectedScore,
    question,
    onSelect,
    onClose
  } = useTrustSurvey()
  const isRendered = isVisible && Boolean(question)

  useEffect(() => {
    if (!isInitialized) return
    onVisibilityChange?.(isRendered)
  }, [isInitialized, isRendered, onVisibilityChange])

  if (!isRendered || !question) {
    return null
  }

  return (
    <Wrapper ref={ref}>
      <SurveyBannerContent
        statement={question.statement}
        selectedScore={selectedScore}
        status={status}
        onSelect={onSelect}
        onClose={onClose}
      />
    </Wrapper>
  )
}
